import { PaymentTerminal, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { SelectField } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { MewsTerminalFormField } from './schema';

export const PaymentTerminalSelectField = ({
    helperTextKey,
    terminalFilter,
}: {
    helperTextKey: Mews.TextKey;
    terminalFilter: (t: PaymentTerminal) => boolean;
}) => {
    const { data = [] } = useRepositorySuspenseQuery('paymentTerminals', 'getAll', {});

    const paymentTerminalOptions = data
        .filter(terminalFilter)
        .map(({ id, name }) => createOption({ value: id, label: name }));

    return (
        <SelectField
            required
            label={lt('PaymentTerminal')}
            helper={lt(helperTextKey)}
            showEmptyValue={false}
            name={MewsTerminalFormField.PaymentTerminalId}
            options={paymentTerminalOptions}
        />
    );
};
